import React, {useEffect, useState} from 'react';
import {EntityLogoRequestParams} from "../../../infrastructure/models/params/entity-logo-request-params";
import {EntityLogoProps} from "./entity-logo";
import {WithDevice} from "../composers/with-device";
import {WithEntityMetadata} from "../composers/with-entity-metadata";

export const EntityLogoComposer = (EntityLogo) => WithEntityMetadata(WithDevice(({
                                                                                   device,
                                                                                   i18n,
                                                                                   entity,
                                                                                   metadata,
                                                                                   ...rest
                                                                                 }: EntityLogoProps) => {

  if (!entity?.logoType) {
    console.warn('missing icon for entity "' + entity.name + '" with id: ' + entity.id);

    return null;
  }

  const [src, setSrc] = useState(null);
  const ratio = device.isSmallView ? 3 : 2;

  const onError = (e) => {
    const logoParams: EntityLogoRequestParams = new entity.logoType({...entity, ...metadata, ratio, ...rest}, entity);

    if (logoParams?.onErrorFallbackUrl?.()) {
      setSrc(logoParams?.onErrorFallbackUrl());
    }
  };

  useEffect(() => {
    const logoParams: EntityLogoRequestParams = new entity.logoType({...metadata, ratio, ...rest}, entity);
    setSrc(logoParams);
  }, [entity?.id]);

  return src === null ? null : <EntityLogo {...rest} alt={metadata?.alt} src={src} onError={onError}/>;
}));
